import { GET } from '@/utils/request'
import Api from './url'
export const getMarketingActivity = async (params: object) => {
  return await GET({ url: Api.getMarketingActivity, params, showError: false })
}
export const queryMarketingActivitySaleList = async (params: object) => {
  return await GET({ url: Api.queryMarketingActivitySaleList, params, showError: false })
}
